<template>
    <div>

        <div v-if="isLoader" class="d-flex justify-content-center">
            <loader-component class=""></loader-component>
        </div>

        <card-component :footer="false" v-if="!isLoader">
            <template v-slot:content>
                <table-component
                    :data="datas.data"
                    :show="{visible : false, target : 'self'}"
                    :update="{visible : false, target : 'self'}"
                    :remove="{visible : false, target: 'modal', dataBsTarget: '#removeModal'}"
                    :column="{
                            id : {title : '#ID', type : 'integer', class : 'd-none d-md-table-cell'},
                            date : { title : 'DATA', type : 'date', class: 'flex-wrap' },
                            dish_chosen : { title : 'Prato', type : 'string', class: '' },
                       }"
                ></table-component>
            </template>

            <template v-slot:footer>


            </template>

        </card-component>


        <!-- botoes concluir e voltar desktop  -->
        <card-component class="mt-3 d-none d-md-block">
            <template slot="content">
                <div class="row">
                    <div class="col-6 d-flex justify-content-center gap-3 offset-3">
                        <button type="button" class="btn btn-primary w-25" @click.prevent="finishOrder">
                            <i class="fa-solid fa-check"></i>&nbsp;Confirmar
                        </button>
                        <button type="button" class="btn btn-primary w-25 ml-3" @click.prevent="goBack">
                            <i class="fa-solid fa-arrow-rotate-left"></i>&nbsp;Voltar
                        </button>
                    </div>
                </div>
            </template>
        </card-component>

        <!-- footer mobile -->
        <footer-component>
            <template slot="content">
                <div class="row">
                    <div class="col-6">
                        <div class="d-flex justify-content-center" style="font-size:37px">
                            <div class="d-flex justify-content-center w-100">
                                <a  @click.prevent="finishOrder" class="link-danger"> <i class="fa-solid fa-check"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex justify-content-center m-1" style="font-size:32px">
                            <div class="d-flex justify-content-center w-100">
                                <a :href="goback_route" class="link-danger"> <i class="fa-solid fa-arrow-rotate-left"></i></a>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
        </footer-component>


    </div>

</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "OrderCustomerEmployeesFinish",
    props: ['get_registers_route', 'goback_route', 'finish_order_route', 'employees_logout'],
    data() {
        return {
            datas: {data: []},
            isLoader: true,
        }
    },

    methods: {

        swal(icon, title, text, goBackRoute) {
            Swal.fire({
                icon: icon,
                title: title,
                text: text,
            }).then((result) => {
                window.location = goBackRoute;
            })
        },

        goBack() {
            window.location = this.goback_route;
        },

        getRegisters() {
            this.isLoader = true;
            axios.get(this.get_registers_route+'/'+$.cookie('employee_register'))
                .then(response => {
                    this.datas.data = response.data;
                    console.log(this.datas.data);
                    this.isLoader = false;
                })
                .catch(error => {
                    this.isLoader = false;
                    console.log(error);
                });
        },

        finishOrder() {
            let url = this.finish_order_route + '/' + $.cookie('employee_register') + '/' + $.cookie('employee_service');

            let formData = new FormData();
            formData.append('_method', 'PUT');

            this.isLoader = true;

            axios.post(url, formData)
                .then(response => {
                    console.log(response.data);
                    this.isLoader = false;
                    if (response.data.success) {
                        this.swal('success', 'Sucesso', response.data.message, this.employees_logout);
                    } else {
                        this.swal('error', 'Erro', response.data.message, this.goback_route);
                    }
                })
                .catch(error => {
                    this.isLoader = false;
                    this.swal('error', 'Erro', error.message, this.goback_route);
                    console.log(error);
                });
        }
    },

    mounted() {
        this.getRegisters();
    },
}
</script>

<style scoped>

</style>
